import { distinctUntilChanged, map, Observable, of, startWith, switchMap } from 'rxjs';

export interface ImageFileUrl {
  id: number;
  localUrl?: string;
}

/** Resolve the current image against downloaded app assets, dropping the previous subscription. */
export function resolveImageUrl$(
  uri$: Observable<string | undefined>,
  files$: Observable<readonly ImageFileUrl[]>,
): Observable<string | undefined> {
  return uri$.pipe(
    distinctUntilChanged(),
    switchMap((uri) => {
      if (!uri?.startsWith('file://')) {
        return of(uri || undefined);
      }

      const id = uri.slice('file://'.length);
      if (!/^\d+$/.test(id)) {
        return of(undefined);
      }

      return files$.pipe(
        map((files) => files.find((file) => file.id === Number(id))?.localUrl),
        startWith(undefined),
      );
    }),
    distinctUntilChanged(),
  );
}
